<template>
  <div id="course">
    <div class="page-title-wrapper" aria-label="Page title">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="mt-n1 mr-1"><i data-feather="home"></i></li>
            <li class="breadcrumb-item">
              <a target="_self" href="/"> Home </a>
            </li>
            <li class="breadcrumb-item">
              <a target="_self" href="/educatie/">Educatie </a>
            </li>
          </ol>
        </nav>
        <h1 v-if="course" class="page-title">{{ course.name }}</h1>
        <span class="d-block mt-2 text-muted"></span>
        <hr class="mt-4" />
      </div>
    </div>
    <div class="container">
      <div
        class="os-header-img-container"
        style="background-image: url('/static/edu/default-edu-banner.jpg')"
      ></div>
    </div>
    <div class="container pb-4">
      <div class="row pt-5">
        <div class="col-lg-7">
          <div class="card bg-light">
            <div ng-editable="course-header-1" class="card-header">
              Beschrijving
            </div>
            <div class="card-body">
              <EditableBlock
                v-if="course.page"
                :blocks="blocks"
                :page_id="course.page.id"
                block_name="algemeen"
                type="internalblocks"
              />
            </div>
          </div>
          <div class="card bg-light mt-3">
            <div ng-editable="course-header-2" class="card-header">Doel</div>

            <div class="card-body">
              <EditableBlock
                v-if="course.page"
                :blocks="blocks"
                :page_id="course.page.id"
                block_name="doel"
                type="internalblocks"
              />
            </div>
          </div>
          <div class="card bg-light mt-3">
            <div ng-editable="course-header-3" class="card-header">Vragen</div>
            <div
              class="card-body"
              v-if="page_store.widgets"
            >
              <div v-html="cursus_vragen"></div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 pt-4 pt-lg-0" id="infoPanels">
          <div class="accordion pt4">
            <div class="card">
              <div class="card-header">
                <h3 class="accordion-heading">
                  <a
                    href=""
                    role="button"
                    data-toggle="collapse"
                    data-target="#cursusData"
                    aria-expanded="true"
                    aria-controls="cursusData"
                  >
                    <span
                      class="d-inline-block pr-2 border-right mr-2 align-middle mt-n1"
                    >
                      <i
                        data-feather="calendar"
                        style="width: 1.1rem; height: 1.1rem"
                      ></i> </span
                    >Startdata
                    <span class="accordion-indicator">
                      <i data-feather="chevron-up"></i>
                    </span>
                  </a>
                </h3>
              </div>
              <div
                class="collapse show"
                id="cursusData"
                data-parent="#infoPanels"
              >
                <div class="card-body p-0" ng-cloak>
                  <div class="list-group">
                    <div
                      v-for="run in runs"
                      :key="run.id"
                      class="list-group-item flex-column align-items-start border-bottom-0 border-left-0 border-right-0"
                    >
                      <div
                        class="d-flex flex-wrap w-100 justify-content-between"
                      >
                        <h6 class="mb-0">
                          {{
                            moment(run.start_date).format("dddd D MMMM YYYY")
                          }}
                        </h6>
                        <small class="text-muted"
                          >Cursus #: {{ run.id }}</small
                        >
                      </div>
                      <!--<span
                        v-if="course.stap_cursus && run.stap_possible"
                        class="badge badge-warning"
                        >STAP nu mogelijk</span
                      >
                      <span
                        v-else-if="course.stap_cursus && run.stap_over"
                        class="badge badge-secondary"
                        >STAP niet meer mogelijk</span
                      >
                      <span
                        v-else-if="course.stap_cursus"
                        class="badge badge-secondary"
                        >STAP vanaf
                        {{
                          moment(run.stap_registration_start).format(
                            "D MMMM YYYY"
                          )
                        }}</span
                      >-->
                      <p class="font-size-sm mt-2 font-weight-normal text-body">
                        {{ run.remarks }}
                        <a
                          href=""
                          :data-target="'#dates-' + run.id"
                          data-toggle="collapse"
                          role="button"
                          aria-expanded="false"
                          aria-controls="collapseExample"
                          >> alle lesdata</a
                        >
                        <small class="collapse" :id="'dates-' + run.id"
                          ><br />{{ run.shortDates }}</small
                        >
                      </p>
                      <div
                        class="d-flex flex-wrap w-100 justify-content-between align-items-center"
                      >
                        <a
                          :href="
                            '/educatie/c/' +
                            course.slug +
                            '/' +
                            run.id +
                            '/inschrijven'
                          "
                          class="btn btn-sm btn-primary"
                          >Nu inschrijven</a
                        >
                        <span class="">€{{ course.price | toFloat }},-</span>
                      </div>
                    </div>
                    <ul class="mr-2">
                      <p v-if="runs.length == 0" class="mt-4">
                        <span>Cursus prijs €{{ course.price | toFloat }},-</span><br/><br/>
                        Neem contact op indien geen data beschikbaar via
                        020 524 60 60 of edu@openstudio.nl
                      </p>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h3 class="accordion-heading">
                  <a
                    href=""
                    role="button"
                    data-toggle="collapse"
                    data-target="#inloopDagen"
                    aria-expanded="false"
                    aria-controls="inloopDagen"
                  >
                    <span
                      class="d-inline-block pr-2 border-right mr-2 align-middle mt-n1"
                    >
                      <i
                        data-feather="coffee"
                        style="width: 1.1rem; height: 1.1rem"
                      ></i> </span
                    >Infodag
                    <span class="accordion-indicator">
                      <i data-feather="chevron-down"></i>
                    </span>
                  </a>
                </h3>
              </div>
              <div class="collapse" id="inloopDagen" data-parent="#infoPanels">
                <div class="card-body">
                  <div ng-editable="block-inloop">
                    <!--{{ blocks.get('block-inloop', '') }}-->
                  </div>
                  <OpenDoorDayWidget />
                  <p>
                    <a href="/infodag/">Meer informatie over deze dagen.</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h3 class="accordion-heading">
                  <a
                    href=""
                    role="button"
                    data-toggle="collapse"
                    data-target="#programma"
                    aria-expanded="true"
                    aria-controls="programma"
                  >
                    <span
                      class="d-inline-block pr-2 border-right mr-2 align-middle mt-n1"
                    >
                      <i
                        data-feather="book-open"
                        style="width: 1.1rem; height: 1.1rem"
                      ></i> </span
                    >Programma
                    <span class="accordion-indicator">
                      <i data-feather="chevron-up"></i>
                    </span>
                  </a>
                </h3>
              </div>
              <div
                class="collapse show"
                id="programma"
                data-parent="#infoPanels"
              >
                <div class="card-body">
                  <table
                    :key="program.id"
                    v-for="(program, loopIndex) in programs"
                    class="table table-borderless table-vcenter"
                  >
                    <tbody>
                      <tr class="active">
                        <th style="width: 50px"></th>
                        <th>
                          {{ loopIndex + 1 }}. Onderdelen van {{ program.name }}
                        </th>
                        <th class="font-s12 text-right">
                          <span class="text-muted"></span>
                        </th>
                      </tr>
                      <tr :key="item.id" v-for="item in program.items">
                        <td class="success text-center">
                          <i class="fa fa-fw fa-check text-success"></i>
                        </td>
                        <td>
                          <p>
                            {{ item.name }}<br />
                          </p>
                        </td>
                        <td class="text-right">
                          <em class="font-s12 text-muted"></em>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div ng-editable="programmablok">
                    <!--{{ blocks.get('programmablok', '') }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.os-header-img-container {
  min-height: 330px;
  max-height: 400px;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-size: 100% auto;
}
</style>

<script>
import axios from "axios";
import { pageStore } from "@/stores/page";
import OpenDoorDayWidget from "@/components/OpenDoorDayWidget.vue";
import EditableBlock from "@/components/EditableBlock.vue";

export default {
  name: "CourseViewEditableBlock",
  components: {
    OpenDoorDayWidget,
    EditableBlock,
  },
  filters: {
    toFloat: function (value) {
      return parseFloat(value);
    },
  },
  data: function () {
    return {
      course: {},
      runs: [],
      programs: [],
      blocks: new Map(),
    };
  },
  created() {
    // watch the params of the route to fetch the data again
    this.$watch(
      () => this.$route.params,
      () => {
        this.fetchData();
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
  },
  computed: {
    cursus_vragen() {
      if (this.page_store.widgets && this.page_store.widgets.get("cursus-vragen")) {
        return this.page_store.widgets.get("cursus-vragen").content
      }
      return ""
    }
  },
  methods: {
    fetchData() {
      var vue = this;
      axios
        .get("/api/courses/" + this.$route.params.slug + "/")
        .then((response) => {
          this.course = response.data;
          axios
            .get("/api/main/internalpages/" + this.course.page.id + "/")
            .then((response) => {
              this.blocks = new Map(
                response.data.blocks.map(function (b) {
                  return [b.name, b];
                })
              );
            });
        });
      var params = {
        params: {
          courses__slug: this.$route.params.slug,
          no_page: true,
        },
      };
      axios
        .get("/api/programs/", params)
        .then((response) => (this.programs = response.data));
      params = {
        params: {
          course__slug: this.$route.params.slug,
          no_page: true,
        },
      };
      axios.get("/api/runs/", params).then((response) => {
        this.runs = response.data;
        this.runs.forEach((run) => {
          run.shortDates = run.dates
            .map(function (d) {
              return vue.moment(d.date).format("DD/MM");
            })
            .join(", ");
        });
      });
    },
  },
  setup() {
    const page_store = pageStore();
    return {
      page_store,
    };
  },
};
</script>
